// AppRoute.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import OurPortfolio from "./components/OurPortfolio";
import AboutAnushthan from "./components/AboutAnushthan";
import Blogs from "./components/Blogs";
import NewBlog from "./components/NewBlog";
import ContactUs from "./components/ContactUs";
import PrivacyPolicy, { PRIVACY_PATH } from "./components/PrivacyPolicy";

const AppRoute = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/case-studies" element={<OurPortfolio></OurPortfolio>} />
        <Route path="/about-us" element={<AboutAnushthan></AboutAnushthan>} />
        <Route path="/blogs" element={<Blogs></Blogs>} />
        <Route path="/admin/new-blog" element={<NewBlog />} />
        <Route path="/contact-us" element={<ContactUs></ContactUs>} />
        <Route path={PRIVACY_PATH} element={<PrivacyPolicy />} />
      </Routes>
    </Router>
  );
};

export default AppRoute;
